/**
 * NAV Inputs Component
 * Financial inputs for Net Asset Value method (Total Assets and Total Liabilities)
 */
import React from 'react';
import PropTypes from 'prop-types';
import { HelpCircle } from 'lucide-react';

const NAVInputs = ({
  formData,
  onInputChange,
  onShowHelp,
  formatNumberWithCommas
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Total Assets */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Total Assets *
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onShowHelp('total_assets');
            }}
            className="ml-1 text-blue-600 hover:text-blue-700"
          >
            <HelpCircle size={14} className="inline" />
          </button>
        </label>
        <div className="relative">
          <span className="absolute left-3 top-3 text-gray-500">$</span>
          <input
            type="text"
            name="total_assets"
            value={formatNumberWithCommas(formData.total_assets)}
            onChange={onInputChange}
            required
            placeholder="2,000,000"
            className="w-full pl-8 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>

      {/* Total Liabilities */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Total Liabilities *
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onShowHelp('total_liabilities');
            }}
            className="ml-1 text-blue-600 hover:text-blue-700"
          >
            <HelpCircle size={14} className="inline" />
          </button>
        </label>
        <div className="relative">
          <span className="absolute left-3 top-3 text-gray-500">$</span>
          <input
            type="text"
            name="total_liabilities"
            value={formatNumberWithCommas(formData.total_liabilities)}
            onChange={onInputChange}
            required
            placeholder="500,000"
            className="w-full pl-8 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>
    </div>
  );
};

NAVInputs.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onShowHelp: PropTypes.func.isRequired,
  formatNumberWithCommas: PropTypes.func.isRequired
};

export default NAVInputs;
